import { render, staticRenderFns } from "./AllCandidates.vue?vue&type=template&id=2e3dd3c9&scoped=true"
import script from "./AllCandidates.vue?vue&type=script&lang=js"
export * from "./AllCandidates.vue?vue&type=script&lang=js"
import style0 from "./AllCandidates.vue?vue&type=style&index=0&id=2e3dd3c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3dd3c9",
  null
  
)

export default component.exports